/**
 * RAM-only handoff for a redeemed patient share record, used to seed a ChartMind
 * encounter from the public /share landing page (where a provider first views the
 * shared record, then chooses to start an encounter with it).
 *
 * HIPAA: the redeemed record contains PHI, so it must NEVER touch localStorage,
 * sessionStorage, cookies, or router history.state (browsers persist those to disk
 * and to session-restore). This module-scoped variable lives only in the running
 * tab's memory, mirroring ChartMindSession's RAM-only model: it dies on refresh and
 * is cleared the instant ChartMind reads it.
 */
let pendingSharedRecord = null;

/** Stash a redeemed record for the next ChartMind mount to pick up. */
export const setPendingSharedRecord = (record) => {
  pendingSharedRecord = record || null;
};

/** Return the pending record (or null) and clear it so it's consumed exactly once. */
export const takePendingSharedRecord = () => {
  const record = pendingSharedRecord;
  pendingSharedRecord = null;
  return record;
};
